import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqContaEntrada = {
	listPaginate: async function (body) {
		return apiServer
			.get("portal/v1/conta-entrada", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listContaEntradaSum: async function (body) {
		return apiServer
			.get("portal/v1/conta-entrada/sum", {
				params: body,
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/conta-entrada/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listIDGroup: async function (id) {
		return apiServer
			.get(`portal/v1/conta-entrada/${id}/venda`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listVendaItens: async function (id_venda) {
		return apiServer
			.get(`portal/v1/vendaitem/venda/${id_venda}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listVendaComplementos: async function (id_venda) {
		return apiServer
			.get(`portal/v1/vendacomplemento/venda/${id_venda}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v2/commitvenda", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	listMovement: async function (param, paramValue, paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/contaentrada/movimentacao", {
				params: {
					param,
					paramValue,
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listMovementFormPayment: async function (param, paramValue, paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/contaentrada/forma-pgto", {
				params: {
					param,
					paramValue,
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listCalcDelivery: async function (param, paramValue, paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/contaentrada/entregas", {
				params: {
					param,
					paramValue,
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listContaEntradaContaSaida: async function (param, paramValue, paramDtIni, paramDtFim) {
		return apiServer
			.get("portal/v1/contaentrada-contasaida", {
				params: {
					param,
					paramValue,
					paramDtIni,
					paramDtFim,
				},
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listReceitaseDespesas: async function (param, dtIni, dtFim) {
		return apiServer
			.get("portal/v1/relatorios/receitas-despesas", {
				params: {
					param,
					dtIni,
					dtFim,
				},
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listReceitasCategoria: async function (param, dtIni, dtFim) {
		return apiServer
			.get("portal/v1/relatorios/conta-entrada/categoria", {
				params: {
					param,
					dtIni,
					dtFim,
				},
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listByVenda: async function (id) {
		return apiServer
			.get(`portal/v1/contaentrada/venda/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqContaEntrada;
